export enum APP_NAMES {
    PORTAL = 'ESTIMATING_PORTAL',
    DIGITIZER = 'ESTIMATING_DIGITIZER',
    USER_SERVICE = 'USER_SERVICE',
}
